import {Inject, Injectable} from '@angular/core';

import { HttpClient } from "@angular/common/http";
import {AbstractService} from "./abstract-service.service";
import {APP_CONFIG, AppConfig} from "./config";
import {DisplayHomeSections} from "../Models/display-home-sections";
import {Observable} from "rxjs";
import {Response} from '../Models/response';

@Injectable({
  providedIn: 'root'
})
export class DisplayService extends   AbstractService<DisplayHomeSections, number>{
  url:string ;
  constructor(http:HttpClient,@Inject(APP_CONFIG) private appConfig: AppConfig)  {
    super(http);
    this.url=`${this.appConfig.apiEndpoint}/DisplayHomeSections`;
  }


  getAllDisplayHomeSections():Observable<Response<DisplayHomeSections[]>>{
     return this.http.get<Response<DisplayHomeSections[]>>(this.url);
  }





}
